import { render, staticRenderFns } from "./BudgetReportExpenses.vue?vue&type=template&id=1040d972"
import script from "./BudgetReportExpenses.vue?vue&type=script&lang=js"
export * from "./BudgetReportExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports